import React, { Component, Fragment } from 'react';
import { Dialog, TableHead, DialogTitle, DialogContent, Typography, IconButton, Grid, Divider, Table, TableBody, TableRow, TableCell, Box, Tooltip, Tabs, Tab, Button } from '@mui/material';
import Currency from '../common/Currency';
import MatchingStatus from '../common/MatchingStatus';
import { spendingMatchingState, spendingRemaining } from '../../utils/matchingState';
import { ArrowBack, CheckCircleRounded, EditRounded, FileCopyRounded, Visibility } from '@mui/icons-material';
import axios from 'axios';
import { isEmpty, size } from "lodash"
import { extension } from 'mime-types'
import {
    isPdfFile,
    isImageFile,
    isInvalidPreviewBlobResponse,
} from '../../utils/spendingAttachment';

class SpendingDetails extends Component {
    filePreviewRequestId = 0;
    state = {
        photos: [],
        tab: 0,
        spending_chantier_part: [],
        spending_purchase_part: [],
        linked_purchases_loading: false,
        linked_purchases_error: null,
        purchase_detail_modal: { open: false, item: null },
        linked_purchases_modal: { open: false },
        // Pièces justificatives (COMPTA-220) — collection spendingFileList,
        // remplace le tableau embarqué legacy spending.spending_files.
        attachmentFiles: [],
        attachmentFilesLoading: false,
        attachmentFilesError: null,
        filePreviews: {},
    }
    openLinkedPurchasesModal = () => {
        this.setState({ linked_purchases_modal: { open: true } });
    }
    closeLinkedPurchasesModal = () => {
        this.setState({ linked_purchases_modal: { open: false } });
    }
    openPurchaseDetailModal = (item) => {
        this.setState({ purchase_detail_modal: { open: true, item } });
    }
    closePurchaseDetailModal = () => {
        this.setState({ purchase_detail_modal: { open: false, item: null } });
    }
    componentDidMount = async () => {
        const { spending_id, spending_payments, spending_total_payed } = this.props.spending;
        if(isEmpty(spending_payments) && spending_total_payed !== 0 ){
            this.props.fetchSpendingPayments && this.props.fetchSpendingPayments(spending_id)
        }
        this.fetchChantierInfo()
        this.fetchPurchaseList()
        this.fetchAttachmentFiles()
    }
    componentDidUpdate(prevProps) {
        const prevSpending = prevProps.spending || {};
        const nextSpending = this.props.spending || {};
        if (prevSpending.spending_id !== nextSpending.spending_id) {
            this.fetchAttachmentFiles();
        }
    }
    componentWillUnmount() {
        this.revokeFilePreviewUrls(this.state.filePreviews);
    }
    revokeFilePreviewUrls = (filePreviews = {}) => {
        Object.values(filePreviews).forEach((item) => {
            if (item?.previewUrl) {
                URL.revokeObjectURL(item.previewUrl);
            }
        });
    }
    // Pièces justificatives (COMPTA-220) — dedicated SpendingFileEntity records
    // (collection spendingFileList), distinct from the legacy embedded
    // spending.spending_files array.
    fetchAttachmentFiles = async () => {
        const spendingId = this.props.spending && this.props.spending.spending_id;
        if (!spendingId) return;
        this.setState({ attachmentFilesLoading: true, attachmentFilesError: null });
        try {
            const res = await axios.get(`/spendings/${spendingId}/files`);
            const list = Array.isArray(res.data)
                ? res.data
                : (Array.isArray(res.data && res.data.data) ? res.data.data : []);
            this.setState({ attachmentFiles: list });
            this.loadFilePreviews(list);
        } catch (err) {
            console.error("fetchAttachmentFiles error", err);
            this.setState({ attachmentFiles: [], attachmentFilesError: "Impossible de charger les pièces justificatives" });
        } finally {
            this.setState({ attachmentFilesLoading: false });
        }
    }
    loadFilePreviews = async (files) => {
        this.filePreviewRequestId += 1;
        const requestId = this.filePreviewRequestId;

        this.revokeFilePreviewUrls(this.state.filePreviews);

        if (isEmpty(files)) {
            this.setState({ filePreviews: {} });
            return;
        }

        const entries = await Promise.all(files.map(async (file) => {
            const key = file.spf_id;
            const downloadUrl = file.spf_file_id ? `/spendings/files/${file.spf_file_id}` : "";
            const isPdf = isPdfFile({ filetype: file.spf_file_type });
            const isImage = isImageFile({ filetype: file.spf_file_type });
            const canPreview = isPdf || isImage;

            if (!downloadUrl) {
                return [key, { notFound: true, loading: false, previewUrl: "", downloadUrl: "" }];
            }
            if (!canPreview) {
                return [key, { notFound: false, loading: false, previewUrl: "", downloadUrl }];
            }

            try {
                const res = await axios.get(downloadUrl, { responseType: "blob" });
                const contentType = `${res?.headers?.["content-type"] || res?.data?.type || ""}`;
                if (isInvalidPreviewBlobResponse(res?.data, contentType)) {
                    return [key, { notFound: true, loading: false, previewUrl: "", downloadUrl }];
                }

                const previewUrl = URL.createObjectURL(res.data);
                return [key, { notFound: false, loading: false, previewUrl, downloadUrl }];
            } catch (error) {
                return [key, { notFound: true, loading: false, previewUrl: "", downloadUrl }];
            }
        }));

        if (requestId !== this.filePreviewRequestId) {
            entries.forEach(([, item]) => {
                if (item?.previewUrl) {
                    URL.revokeObjectURL(item.previewUrl);
                }
            });
            return;
        }

        this.setState({ filePreviews: Object.fromEntries(entries) });
    }
    fetchChantierInfo = async () => {
        const res = await axios.post("/chantiers/spending/part/list", { data: this.props.spending.spending_id })
        console.log({res});
        if (!isEmpty(res)){
            this.setState({spending_chantier_part: res.data})
        }

    }
    fetchEquipementInfo = async () => {
        const res = await axios.post("/equipements/spending/part/list", { data: this.props.spending.spending_id })
        console.log({res});
        if (!isEmpty(res)){
            this.setState({spending_equipement_part: res.data})
        }

    }
    fetchPurchaseList = async () => {
        this.setState({ linked_purchases_loading: true, linked_purchases_error: null });
        try {
            const res = await axios.get(`/spendings/${this.props.spending.spending_id}/linked-purchases`);
            this.setState({
                spending_purchase_part: Array.isArray(res.data) ? res.data : [],
                linked_purchases_loading: false,
            });
        } catch (err) {
            console.error("fetchPurchaseList error", err);
            this.setState({
                spending_purchase_part: [],
                linked_purchases_error: "Impossible de charger les achats 8000 liés",
                linked_purchases_loading: false,
            });
        }
    }
    displayLabels = (labels) => {
        const { LABELS } = this.props;
        
        return labels.split(', ').map(label => LABELS && LABELS[label] && LABELS[label].label_name).join(", ")
    }
    displayProjects = (projects) => {
        const { PROJECTS } = this.props;
        console.log('====================================');
        console.log(projects, PROJECTS);
        console.log('====================================');
        return projects.split(', ').map(project => PROJECTS && PROJECTS[project] && PROJECTS[project].project_name).join(", ")
    }

    render() {
        const { spending, category, BANKS, PAYMENTS } = this.props

        // Safely compute shade only if category_color exists
        let shade = category && category.category_color ? category.category_color.slice(1, 2) : null;
        let textColor = "black"
        if (shade) {
            if (!isNaN(shade)) {
                textColor = "white"
            }
        }
        
        console.log('====================================');
        console.log({spending});
        console.log('====================================');
        const files = this.state.attachmentFiles;
        // La règle vit dans utils/matchingState, partagée avec les recettes et les listes.
        const matching = spendingMatchingState(spending);
        const remainingToMatch = spendingRemaining(spending) || 0;
        return (
            <Fragment>
            <Dialog
                open={true}
                onClose={this.props.handleClose}
                aria-labelledby="form-dialog-title"
                maxWidth="lg"
                fullWidth
                scroll="paper"
                sx={{ zIndex: 13000 }}
                PaperProps={{ sx: { zIndex: 13000 } }}>
                <DialogTitle style={{backgroundColor: category && category.category_color, color: textColor}}>
                    <IconButton
                        color="inherit"
                        onClick={this.props.handleClose}
                        aria-label="Close"
                        size="large">
                        <ArrowBack /> 
                    </IconButton>
                    {category && (category.category_accounting_id ? `${category.category_accounting_id} - ${category.category_name}` : category.category_name)}
                </DialogTitle>
                <DialogContent>
                    <Typography variant="h6" style={{textAlign: "center"}}><Currency value={spending.spending_amountTTC} /></Typography>
                    <Divider />
                    <Grid container spacing={2} style={{marginTop: "20px"}}>
                        <Grid item xs={12}>
                            <Box style={{ textAlign: 'right'}}>
                                <Tooltip title="Copier l'ID Facture" placement="left">
                                    <IconButton
                                        onClick={() => {
                                            navigator.clipboard.writeText(spending.spending_id); 
                                            this.setState({ copied : true })
                                        }}
                                        color="secondary"
                                        size="large">
                                        {this.state.copied ? <CheckCircleRounded /> : <FileCopyRounded />}
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6}>

                            <Table className="table">
                                <TableBody>
                                    <TableRow>
                                        <TableCell> 
                                            <Typography variant="button">Montant HT:</Typography></TableCell>
                                        <TableCell><Currency value={spending.spending_amount} /></TableCell>
                                    </TableRow>
                                    {this.props.view === "ADMIN" &&
                                        <Fragment>
                                            <TableRow>
                                                <TableCell> 
                                                    <Typography variant="button">TVA:</Typography></TableCell>
                                                <TableCell><Currency value={spending.spending_TVA} /></TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell> 
                                                    <Typography variant="button">Autres Taxes:</Typography></TableCell>
                                                <TableCell><Currency value={spending.spending_taxes} /></TableCell>
                                            </TableRow>
                                        </Fragment>
                                    }
                                    
                                    <TableRow>
                                        <TableCell> 
                                            <Typography variant="button">Montant TTC:</Typography></TableCell>
                                        <TableCell><Currency value={spending.spending_amountTTC || spending.spending_amount} /></TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <Typography variant="button">Pointé:</Typography>
                                        </TableCell>
                                        <TableCell>
                                            <MatchingStatus state={matching} showRemaining={false} showLabel />
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell> 
                                            <Typography variant="button">Restant à pointer:</Typography>
                                        </TableCell>
                                        <TableCell><Currency value={remainingToMatch} /></TableCell>
                                    </TableRow>
                                    
                                    <TableRow>
                                        <TableCell> 
                                            <Typography variant="button">Payé le:</Typography>
                                        </TableCell>
                                        <TableCell>{new Date(spending.spending_date).toLocaleDateString("fr-FR")}
                                        </TableCell>
                                    </TableRow>
                                    
                                    <TableRow>
                                        <TableCell>
                                            <Typography variant="button">Description:</Typography>
                                        </TableCell>
                                        <TableCell>{spending.spending_desc}</TableCell>
                                    </TableRow>
                                    {this.props.view === "ADMIN" && (
                                        <TableRow>
                                            <TableCell>
                                                <Typography variant="button">Achats 8000:</Typography>
                                            </TableCell>
                                            <TableCell>
                                                {this.state.linked_purchases_loading
                                                    ? <Typography variant="body2" color="textSecondary">Chargement…</Typography>
                                                    : this.state.linked_purchases_error
                                                        ? <Typography color="error" variant="body2">⚠️ {this.state.linked_purchases_error}</Typography>
                                                        : isEmpty(this.state.spending_purchase_part)
                                                            ? <Typography variant="body2" color="textSecondary">Aucun achat 8000 lié</Typography>
                                                            : (
                                                                <Button
                                                                    variant="outlined"
                                                                    color="primary"
                                                                    size="small"
                                                                    onClick={this.openLinkedPurchasesModal}
                                                                >
                                                                    Voir les achats 8000 liés ({this.state.spending_purchase_part.length})
                                                                </Button>
                                                            )
                                                }
                                            </TableCell>
                                        </TableRow>
                                    )}
                                    <TableRow>
                                        <TableCell>
                                            <Typography variant="button">Remarques:</Typography>
                                        </TableCell>
                                        <TableCell>{spending.spending_remarks}</TableCell>
                                    </TableRow>
                                    {spending.spending_demand && (
                                        <TableRow>
                                            <TableCell> 
                                                <Typography variant="button">Demande de dépense:</Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    size="small"
                                                    startIcon={<Visibility />}
                                                    onClick={() => {
                                                        const url = this.props.view === "ADMIN"
                                                            ? `/admin/spendings_demand?spending_demand_id=${spending.spending_demand}`
                                                            : `/spendings?spending_demand_id=${spending.spending_demand}`;
                                                        window.location.href = url;
                                                    }}
                                                    style={{ textTransform: 'none' }}
                                                >
                                                    Voir la demande
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                    {this.props.view === "ADMIN" &&
                                    (spending.spending_status === "WAITING_VALIDATION" || spending.spending_status === "WAITING_UPDATE" || spending.spending_status === "VALIDATE") &&
                                    this.props.onCompleteSpending && (
                                        <TableRow>
                                            <TableCell> 
                                                <Typography variant="button">Action:</Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    size="small"
                                                    startIcon={<EditRounded />}
                                                    onClick={() => this.props.onCompleteSpending(spending)}
                                                    style={{ textTransform: 'none' }}
                                                >
                                                    {spending.spending_status === "VALIDATE" ? "Modifier la dépense" : "Compléter la dépense"}
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                    {this.props.view === "ADMIN" &&
                                    <Fragment>
                                        <TableRow>
                                            <TableCell> 
                                                <Typography variant="button">Labels:</Typography>
                                            </TableCell>
                                            <TableCell>{spending.spending_labels && this.displayLabels(spending.spending_labels)}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell> 
                                                <Typography variant="button">Projets:</Typography>
                                            </TableCell>
                                            <TableCell>{spending.spending_project && this.displayProjects(spending.spending_project)}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell> 
                                                <Typography variant="button">Total Payé:</Typography>
                                            </TableCell>
                                            <TableCell><Currency value={spending.spending_total_payed} /></TableCell>
                                        </TableRow>

                                    </Fragment>
                                    }
                                </TableBody>
                            </Table>
                            
                        </Grid>
                        <Grid item xs={12} sm={6} >
                            {this.state.attachmentFilesLoading &&
                                <Typography variant="body2" color="textSecondary">Chargement des justificatifs...</Typography>
                            }
                            {this.state.attachmentFilesError &&
                                <Typography variant="body2" color="error">{this.state.attachmentFilesError}</Typography>
                            }
                            {files.length > 0 &&
                                <Grid container spacing={3}>
                                    {files.map((photo, index) => {
                                        const preview = this.state.filePreviews[photo.spf_id];
                                        const fileUrl = preview?.previewUrl || "";
                                        const downloadUrl = preview?.downloadUrl || (photo.spf_file_id ? `/spendings/files/${photo.spf_file_id}` : "");
                                        const downloadName = photo.spf_file_name || `fichier${index + 1}.${extension(photo.spf_file_type) || "bin"}`;

                                        if (preview?.notFound || !downloadUrl) {
                                            return (
                                                <Grid key={photo.spf_id || `missing-file-${index}`} item xs={12}>
                                                    <Typography variant="body2" color="error">
                                                        Justificatif introuvable.
                                                    </Typography>
                                                </Grid>
                                            );
                                        }

                                        if (photo.spf_file_type === "application/pdf") {
                                            return (
                                                <Grid key={photo.spf_id || `pdf-${index}`} item xs={12}>
                                                    <a href={downloadUrl}
                                                        download={downloadName}
                                                    >
                                                        {fileUrl ? (
                                                            <embed
                                                                src={fileUrl}
                                                                width="100%"
                                                                height="400px"
                                                                title={`fichier${index + 1}`}
                                                                type="application/pdf"
                                                            />
                                                        ) : (
                                                            <Typography variant="body2">Chargement du justificatif...</Typography>
                                                        )}
                                                    </a>
                                                </Grid>
                                            );
                                        }

                                        return (
                                            <Grid key={photo.spf_id || `img-${index}`} item xs={6}>
                                                <a href={downloadUrl}
                                                    download={downloadName}
                                                >
                                                    {fileUrl ? (
                                                        <img
                                                            src={fileUrl}
                                                            title={`fichier${index + 1}`}
                                                            alt={`fichier${index + 1}`}
                                                        />
                                                    ) : (
                                                        <Typography variant="body2">Chargement du justificatif...</Typography>
                                                    )}
                                                </a>
                                            </Grid>
                                        );
                                    })}
                                </Grid>
                            }
                        {/* {size(photos) > 0 &&
                            <Grid container spacing={3}>
                                {Object.keys(photos).map( (ID, index) => (
                                    <Fragment>
                                        {photos[ID].startsWith("data:application/pdf") &&
                                            <Grid key={ID} item xs={12} >
                                                <a href={photos[ID]} download={`fichier${index + 1}.${ extension(spending.spending_files[index].filetype) || "pdf"}`}>
                                                    <embed src={photos[ID]} width="100%" height="400px" title={`fichier${index + 1}`} type="application/pdf" />
                                                </a>
                                            </Grid>
                                        }

                                        {!photos[ID].startsWith("data:application/pdf") &&
                                            <Grid key={ID} item xs={6} >
                                                <a href={photos[ID]} download={`fichier${index + 1}.${ extension(spending.spending_files[index].filetype) || "pdf"}`}>
                                                    <img src={photos[ID]} title={`fichier${index + 1}`} alt={`fichier${index + 1}`} />
                                                </a>
                                            </Grid>
                                        }
                                    </Fragment>
                                    )) }
                            </Grid>
                        } */}

                        </Grid>
                        {this.props.view === "ADMIN" &&
                        !isEmpty(BANKS) &&
                        !isEmpty(PAYMENTS) &&
                        (!isEmpty(spending.spending_payments) || !isEmpty(this.state.spending_chantier_part)) &&
                            <Grid item xs={12} >
                                <hr/>

                                <Tabs
                                    value={this.state.tab}
                                    onChange={(e, tab) => this.setState({ tab })}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    variant="fullWidth"
                                    scrollButtons="auto"
                                    // variant="scrollable"
                                >
                                    <Tab label="Paiements" />
                                    <Tab label="Chantiers" />
                                </Tabs>
                                <Box>
                                    
                                { this.state.tab === 0 ?
                                    <Box>
                                        {/* <p>Liste des Paiements</p> */}
                                        {!isEmpty(spending.spending_payments) &&
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>Date</TableCell>
                                                        <TableCell>Banque</TableCell>
                                                        <TableCell>Montant</TableCell>
                                                        <TableCell>Mode</TableCell>
                                                        <TableCell>Ref</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    { spending.spending_payments.map(item =>  {

                                                        // let payInfo = PAYMENTS[item.payment_info_id]
                                                        // let bank = payInfo && BANKS[payInfo.payment_bank]
                                                        let bank = item.payment_details_bank && BANKS[item.payment_details_bank]

                                                        return (
                                                            <TableRow hover key={item.payment_id} className="">
                                                                <TableCell>{new Date(item.payment_details_date).toLocaleDateString("fr-FR")}</TableCell>
                                                                <TableCell>{bank && bank.bank_name}</TableCell>
                                                                <TableCell><Currency value={item.payment_amount} /></TableCell>
                                                                <TableCell>{item.payment_details_mode}</TableCell>
                                                                <TableCell>{item.payment_details_ref}</TableCell>
                                                            </TableRow>
                                                        )
                                                    })
                                                    }
                                                </TableBody>
                                            </Table>
                                        }
                                    </Box>
                                :
                                    <Box>
                                        {/* <p>Liste des Chantiers</p> */}
                                        {!isEmpty(this.state.spending_chantier_part) &&
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        {/* <TableCell>Chantier</TableCell> */}
                                                        <TableCell>Nom</TableCell>
                                                        <TableCell>Montant</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    { this.state.spending_chantier_part.map(item => (
                                                            <TableRow hover key={item.chantier_id} className="">

                                                                <TableCell>{item.chantier_name}</TableCell>
                                                                <TableCell><Currency value={item.chantier_amount} /></TableCell>
                                                            </TableRow>
                                                        ))
                                                    }
                                                </TableBody>
                                            </Table>
                                        }
                                    </Box>
                                }
                                </Box>
                            </Grid>
                        }
                    </Grid>
                </DialogContent>
            </Dialog>
            {this.state.linked_purchases_modal.open && (
                <Dialog
                    open
                    onClose={this.closeLinkedPurchasesModal}
                    fullWidth
                    maxWidth="md"
                >
                    <DialogTitle>Achats 8000 liés à cette dépense</DialogTitle>
                    <DialogContent>
                        {this.state.linked_purchases_loading &&
                            <Typography>Chargement des achats liés…</Typography>
                        }
                        {this.state.linked_purchases_error &&
                            <Typography color="error">{this.state.linked_purchases_error}</Typography>
                        }
                        {!this.state.linked_purchases_loading
                            && !this.state.linked_purchases_error
                            && isEmpty(this.state.spending_purchase_part) &&
                            <Typography>Aucun achat 8000 lié à cette dépense.</Typography>
                        }
                        {!isEmpty(this.state.spending_purchase_part) &&
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Date d'achat</TableCell>
                                        <TableCell>Shop</TableCell>
                                        <TableCell align="right">Montant rattaché</TableCell>
                                        <TableCell align="right">Prix d'achat total</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    { this.state.spending_purchase_part.map(item => {
                                        const items = item.items || [];
                                        const canOpen = items.length > 0;
                                        return (
                                            <TableRow
                                                hover
                                                key={item.purchase_id}
                                                style={{
                                                    cursor: canOpen ? "pointer" : "default",
                                                    ...(item.status === "orphan" ? { opacity: 0.6 } : {}),
                                                }}
                                                onClick={canOpen ? () => this.openPurchaseDetailModal(item) : undefined}
                                            >
                                                <TableCell>
                                                    {item.purchase_date
                                                        ? new Date(item.purchase_date).toLocaleDateString("fr-FR")
                                                        : "—"}
                                                </TableCell>
                                                <TableCell>{item.shop_name || "—"}</TableCell>
                                                <TableCell align="right">
                                                    <Currency value={item.link_amount} />
                                                </TableCell>
                                                <TableCell align="right">
                                                    {item.purchase_total_amount
                                                        ? <Currency value={item.purchase_total_amount} />
                                                        : "—"}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    }) }
                                </TableBody>
                            </Table>
                        }
                        <Box style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
                            <Button onClick={this.closeLinkedPurchasesModal} color="primary">
                                Fermer
                            </Button>
                        </Box>
                    </DialogContent>
                </Dialog>
            )}
            {this.state.purchase_detail_modal.open && this.state.purchase_detail_modal.item && (
                <Dialog
                    open
                    onClose={this.closePurchaseDetailModal}
                    fullWidth
                    maxWidth="md"
                >
                    <DialogTitle>
                        Détails de l'achat 8000
                        <Typography variant="body2" color="textSecondary">
                            {this.state.purchase_detail_modal.item.purchase_date
                                ? new Date(this.state.purchase_detail_modal.item.purchase_date).toLocaleDateString("fr-FR")
                                : "—"}
                            {" — "}
                            {this.state.purchase_detail_modal.item.shop_name || "—"}
                        </Typography>
                        <Typography variant="caption" color="textSecondary" style={{ display: "block", marginTop: 4, fontFamily: "monospace" }}>
                            ID achat : {this.state.purchase_detail_modal.item.purchase_id}
                        </Typography>
                    </DialogTitle>
                    <DialogContent>
                        {isEmpty(this.state.purchase_detail_modal.item.items)
                            ? <Typography>Aucun item pour cet achat.</Typography>
                            : (
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Produit</TableCell>
                                            <TableCell align="right">Quantité</TableCell>
                                            <TableCell align="right">Prix unitaire</TableCell>
                                            <TableCell align="right">Total TTC</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.purchase_detail_modal.item.items.map((sub, idx) => (
                                            <TableRow key={sub.product_id ? `${sub.product_id}-${idx}` : `item-${idx}`}>
                                                <TableCell>{sub.product_name || sub.product_id || "—"}</TableCell>
                                                <TableCell align="right">{sub.quantity}</TableCell>
                                                <TableCell align="right">
                                                    {sub.unit_price
                                                        ? <Currency value={sub.unit_price} />
                                                        : "—"}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {sub.total_price
                                                        ? <Currency value={sub.total_price} />
                                                        : "—"}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            )
                        }
                        <Box style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
                            <Button onClick={this.closePurchaseDetailModal} color="primary">
                                Fermer
                            </Button>
                        </Box>
                    </DialogContent>
                </Dialog>
            )}
            </Fragment>
        );
    }
}

export default SpendingDetails;